import {CommandBase} from "./commandBase";
import {RemoteConstantsModel, UnitUpgradeTrack} from "../models/remoteConstants.model";

// Mutator-style edit of one Unit Upgrade track (its type, stat or a level's numbers), as
// UpdateBuildingPassiveRewardCommand does for a reward: one command for every field.
export class UpdateUnitUpgradeTrackCommand extends CommandBase {
    uid: string;
    change: (track: UnitUpgradeTrack) => void;

    constructor(uid: string, change: (track: UnitUpgradeTrack) => void) {
        super();
        this.uid = uid;
        this.change = change;
    }

    execute(data: RemoteConstantsModel): boolean {
        const track = data.unitUpgrades?.find(t => t.uid === this.uid);
        if (!track) return false;
        this.change(track);
        return true;
    }
}
